import React from 'react';

import IFormFieldProps from 'pods/forms/components/formFieldProps.d';

import * as S from './Section.style';

interface IProps extends IFormFieldProps {
	children: any;
}

const Section = ({ config, children }: IProps) => {
	const { data = {} } = config;
	const { margin, padding, hasBorderTop, hasBorderBottom, customCss } = data;

	return (
		<S.Wrapper
			{...{ margin, padding, hasBorderTop, hasBorderBottom, customCss }}
		>
			{children}
		</S.Wrapper>
	);
};

export default Section;
